export default {"src":"/_next/static/media/deco_logo_skillzpowered.89fa13d4.svg","height":69,"width":135,"blurWidth":0,"blurHeight":0};